// extracted by css-extract-rspack-plugin
export default {"text":"text-F1ZSGZ"};